import styled from "styled-components";
import {tokens} from "../../../theme";
import {Avatar} from "@mui/material";

export const StyledLicenseManagementPage = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 1200px;
    width: 100%;
    height: 100%;
`;

interface MainContainerProps {
    $row?: boolean;
}

export const StyledCard = styled.div<MainContainerProps>`
    display: flex;
    flex: 1;
    flex-direction: ${({$row}) => $row ? 'row' : 'column'};
    min-height: 0;
    overflow: auto;
    padding: 40px;
    gap: 2rem;
    
    border-radius: ${tokens.radius['4xl']};
    border: 1px solid  ${({theme}) => theme.palette.dividers.subtle};
    background-color: ${({theme}) => theme.palette.background.paper};
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.02);
`;

export const StyledContent = styled.div`
    display: flex;
    flex: 1;
    align-items: flex-start;
    justify-content: center;
    min-height: 0;
    overflow: auto;
    margin-top: 24px;
`;

export const LicenseAvatar = styled(Avatar)`
    width: 72px;
    height: 72px;
    font-size: 20px;
    background-color: ${({theme}) => theme.palette.primary.main};
    color: ${({theme}) => theme.palette.primary.contrastText};
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
`;